<template>
<div class="shareData np-marketing-analysis">
    <div class="total bgc">
        <div class="left">
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <el-tooltip content="活动的海报生成总数" placement="top">
                            <div class="name">
                                <span>总海报生成量</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-blue">{{shareinfo.postercount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip content="通过普通链接进入活动的次数" placement="top">
                            <div class="name">
                                <span>总链接分享数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-green">{{shareinfo.linksharecount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip content="通过海报链接进入活动的次数" placement="top">
                            <div class="name">
                                <span>总海报分享数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{shareinfo.postersharecount}}</div>
                    </div>
                </div>
            </div>
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的海报生成数'" placement="top">
                            <div class="name">
                                <span>时段海报生成数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-blue">{{summaryinfo.postercreatecount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的链接分享数'" placement="top">
                            <div class="name">
                                <span>时段链接分享数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-green">{{summaryinfo.linkviewcount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的海报分享数'" placement="top">
                            <div class="name">
                                <span>时段海报分享数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{summaryinfo.posterviewcount}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="filters padding-20 bgc">
                <div class="add">
                    <el-button type="danger" @click="handleQuery(1)" :class="[param.timetype!=1?'is-disabled': '']">今天</el-button>
                    <el-button type="primary" @click="handleQuery(2)" :class="[param.timetype!=2?'is-disabled': '']">昨天</el-button>
                    <el-button type="success" @click="handleQuery(3)" :class="[param.timetype!=3?'is-disabled': '']">近7天</el-button>
                    <el-button type="warning" @click="handleQuery(4)" :class="[param.timetype!=4?'is-disabled': '']">近30天</el-button>
                </div>
                <div class="search">
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" @click="handleQuery(0)">确认筛选</el-button>
                    <el-button type="success" @click="handleExport">下载表格</el-button>
                </div>
            </div>
            <div>
                <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
            </div>
        </div>
    </div>
    <div class="list">
        <div class="dateTime blod"><span class="blod">{{summaryinfo.begindate}}</span> 至 <span class="blod">{{summaryinfo.enddate}}</span></div>
        <div class="result-list btn-operate-list bgc">
            <el-table :data="tableData" style="width: 100%" border>
                <el-table-column prop="date" label="时间" class-name="center"></el-table-column>
                <el-table-column prop="postercreatecount" label="海报生成量" class-name="center"></el-table-column>
                <el-table-column prop="linkviewcount" label="链接分享数" class-name="center"></el-table-column>
                <el-table-column prop="posterviewcount" label="海报分享数" class-name="center"></el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import LineReport from 'base/echarts/lineReport'
import {mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import {getDataStatisticsByShare, exportDataStatisticsByShare, getDataSummary} from 'api/nationalDistribution'
export default {
    name: 'shareData',
    data() {
        return {
            init: false,
            tableData: [],
            summaryinfo: {
                begindate: '',
                enddate: '',
                postercreatecount: '', // 海报生成数
                linkviewcount: '', // 链接分享数
                posterviewcount: '' // 海报分享数
            },
            lineDatas: {id: 'shareData', subText: '', xdata: [], data: [], legendAddr: 'left', formatter: '{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}'},
            date: [],
            datatype: 4, // 1用户统计 2订单统计 3财务统计 4分享统计 5裂变统计
            param: {
                timetype: 3, // 时间类型 0自定义 1今日 2昨日 3近7日 4近30日
                eventinnerid: '',
                begindate: '',
                enddate: ''
            },
            shareinfo: {
                postercount: '', // 海报生成数
                linksharecount: '', // 链接分享数
                postersharecount: '' // 海报分享数
            }
        }
    },
    mounted() {
    },
    methods: {
        handleQuery(index) {
            if (!index && !this.date.length) {
                this.$message.error('请选择筛选日期')
                return false
            } else if (!index && !!this.date.length) {
                this.param.begindate = this.date[0]
                this.param.enddate = this.date[1]
            }
            this.param.timetype = index
            this._getTotal()
        },
        getTotal(param) {
            this.param.eventinnerid = param.eventinnerid
            if (!this.init) {
                this._getDataSummary()
                this._getTotal()
            }
        },
        handleExport() {
            this.setLoading(true)
            exportDataStatisticsByShare({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '分享数据' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getTotal() {
            this.setLoading(true)
            getDataStatisticsByShare({
                data: this.param,
                success: data => {
                    this.tableData = data.data.datalist
                    this.summaryinfo = data.data.summaryinfo
                    let xdata = []
                    let [ydata1, ydata2, ydata3] = [[], [], []]
                    this.tableData.forEach((obj) => {
                        xdata.push(obj.date)
                        ydata1.push(obj.postercreatecount)
                        ydata2.push(obj.linkviewcount)
                        ydata3.push(obj.posterviewcount)
                    })
                    this.lineDatas.xdata = xdata
                    this.lineDatas.data=[]
                    this.lineDatas.data.push(
                        {
                            title: '海报生成量',
                            color: '#1989FA',
                            smooth: true,
                            symbol: 'circle',
                            list: ydata1
                        },
                        {
                            title: '链接分享数',
                            color: '#67C23A',
                            smooth: true,
                            symbol: 'circle',
                            list: ydata2
                        },
                        {
                            title: '海报分享数',
                            color: '#F56C6C',
                            smooth: true,
                            symbol: 'circle',
                            list: ydata3
                        }
                    )
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getDataSummary() {
            getDataSummary({
                data: {eventinnerid: this.param.eventinnerid, datatype: this.datatype},
                success: data => {
                    this.init = true
                    this.shareinfo = data.data.shareinfo
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.shareData{

}
</style>
